export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M.936 2.184C.5 3.04.5 4.16.5 6.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 001.748 1.748C3.54 20 4.66 20 6.9 20h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 001.748-1.748c.436-.856.436-1.976.436-4.216V6.4c0-2.24 0-3.36-.436-4.216A4 4 0 0018.316.436C17.46 0 16.34 0 14.1 0H6.9C4.66 0 3.54 0 2.684.436A4 4 0 00.936 2.184zM11.245 17.3v-6.743h2.84l.428-2.514h-3.268V6.87c0-.91.718-1.657 1.616-1.657h1.69V2.7h-1.69c-2.231 0-4.05 1.862-4.05 4.171v1.172h-2.36v2.514h2.36V17.3h2.434z"/>
  `,
  title: 'Facebook',
  viewBox: '0 0 21 20',
};
